import ArrowBack from "@mui/icons-material/ArrowBack";
import { Chip, IconButton, Stack } from "@mui/material";
import { StatusChip } from "components/StatusChip";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { WorkflowStatus } from "generated-graphql/graphql";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";
import { workflowStatusColor } from "routes/Staff/Work/statusChipColors";

type WorkDetailHeaderProps = {
  workTypeLabel?: string | null;
  status: WorkflowStatus;
  tenantName: string;
  programArea?: string | null;
  due: DateTime | null;
  dueType?: string | null;
  overdue: boolean;
};

/**
 * Back affordance plus the deliverable's property chips. There is no in-page
 * title on purpose: the app header's breadcrumb already carries the name.
 */
export function WorkDetailHeader({
  workTypeLabel,
  status,
  tenantName,
  programArea,
  due,
  dueType,
  overdue,
}: WorkDetailHeaderProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <IconButton component={Link} to="/staff/work" aria-label="back to work queue">
        <ArrowBack />
      </IconButton>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
        sx={{ flex: 1, minWidth: 0 }}
      >
        <Chip size="small" label={workTypeLabel ?? "Custom deliverable"} />
        {/* Status is state-by-color, so it goes through StatusChip (soft fill)
            exactly as the drawer renders the same value. */}
        <StatusChip color={workflowStatusColor(status)} label={prettyPrintEnumValue(status)} />
        <Chip size="small" variant="outlined" label={tenantName} />
        {programArea && <Chip size="small" variant="outlined" label={programArea} />}
        {due && (
          <StatusChip
            variant="outlined"
            color={overdue ? "error" : "default"}
            label={`Due ${due.toLocaleString(DateTime.DATE_MED)}${
              dueType ? ` · ${prettyPrintEnumValue(dueType)}` : ""
            }`}
          />
        )}
      </Stack>
    </Stack>
  );
}
